import axios from 'axios'

import { API_ENDPOINTS, COMPLAINTS } from '@/constants'

const PRODUCTION_DEPARTMENTS_URL = '/production-departments/dicts/production-departments'

const fetchComplaints = (queryString = '') => {
    const url = `/complaints/complaints${queryString ? `?${queryString}` : ''}`
    return axios.get(url)
}

const generateComplaintsReport = (queryString = '') => {
    return axios.get(`/complaints/complaints?report=true${queryString}`, {
        timeout: 120000
    })
}

const fetchComplaintTypes = () => {
    return axios.get('/complaints/complaints/dicts/complaint-types')
}

const fetchComplaintStatuses = () => {
    return axios.get('/complaints/complaints/dicts/statuses')
}

const fetchProductionDepartments = (filter = null) => {
    const url = filter ? `${PRODUCTION_DEPARTMENTS_URL}?${filter}` : PRODUCTION_DEPARTMENTS_URL
    return axios.get(url)
}

const fetchComplaintById = (id) => {
    return axios.get(`/complaints/complaints/${id}`)
}

const createComplaint = (payload) => {
    return axios.post('/complaints/complaints', payload)
}

const updateComplaint = (id, payload) => {
    return axios.put(`/complaints/complaints/${id}`, payload)
}

const fetchComplaintErrors = () => {
    return axios.get('/complaints/complaints/complaint-errors')
}

const createComplaintError = (payload) => {
    return axios.post('/complaints/complaints/complaint-errors', payload)
}

const uploadComplaintAttachment = (formData, config = {}) => {
    return axios.post('/complaints/complaints/file/upload', formData, config)
}

const deleteComplaintAttachment = (id) => {
    return axios.delete(`/complaints/complaints/file/upload/${id}`)
}

const createComplaintComment = (payload) => {
    return axios.post('/complaints/complaint-comments', payload)
}

const downloadComplaintCard = (payload) => {
    return axios.post('/complaints/print-complaint-card', payload, {
        responseType: 'arraybuffer'
    })
}

const fetchComplaintStatusHistory = (id) => {
    return axios.get(`/complaints/complaints/${id}/status-history`)
}

const deleteComplaint = (id) => {
    return axios.delete(`/complaints/complaints/${id}`)
}

const fetchJobNumbers = (query) => {
    return axios.get(API_ENDPOINTS.COMPLAINTS.JOB_NUMBERS, {
        params: { jobNumber: query, limit: COMPLAINTS.NUMBERS_SEARCH_LIMIT }
    })
}

const fetchOrderNumbers = (query) => {
    return axios.get(API_ENDPOINTS.COMPLAINTS.ORDER_NUMBERS, {
        params: { orderNumber: query, limit: COMPLAINTS.NUMBERS_SEARCH_LIMIT }
    })
}

export default {
    fetchComplaints,
    generateComplaintsReport,
    fetchComplaintTypes,
    fetchComplaintStatuses,
    fetchProductionDepartments,
    fetchComplaintById,
    createComplaint,
    updateComplaint,
    fetchComplaintErrors,
    createComplaintError,
    uploadComplaintAttachment,
    deleteComplaintAttachment,
    createComplaintComment,
    downloadComplaintCard,
    fetchComplaintStatusHistory,
    deleteComplaint,
    fetchJobNumbers,
    fetchOrderNumbers
}
